import { Form, useFormikContext } from "formik";
import {
	ClassicInputGroup,
	BooleanInputGroup,
	DropdownInputGroup,
	FieldType
} from "@typedefs/modulesInterfaces";
import { useGetCountriesQuery } from "@hooks/index";
import { useMemo } from "react";
import { useHandleLogout } from "./utils";
import TranslatableText from "@components/translations/TranslatableText";
import GenericInputGroup from "@components/input/inputGroup/GenericInputGroup";
import FormActionButtons from "@components/button/FormActionButtons";
import ProjectNotificationsSection from "./ProjectNotificationsSection";

const UserModalForm = () => {
	return (
		<Form className="w-100 d-flex f-column justify-content-between">
			<PersonalInfoForm />
			<Footer />
		</Form>
	);
};

const PersonalInfoForm = () => {
	const { data: countries, isLoading } = useGetCountriesQuery();

	const piInputs: ClassicInputGroup[] = [
		{
			type: FieldType.CLASSIC,
			inputName: "first_name",
			inputType: "text",
			label: "user.first_name",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "last_name",
			inputType: "text",
			label: "user.last_name",
		},
		{
			type: FieldType.CLASSIC,
			inputName: "organization",
			inputType: "text",
			label: "user.organization",
		},
		// {
		// 	type: FieldType.CLASSIC,
		// 	inputName: "affiliations",
		// 	inputType: "text",
		// 	label: "user.affiliations",
		// 	disabled: true,
		// },
		/* {
			type: FieldType.CLASSIC,
			inputName: "mobileNumber",
			inputType: "text",
			label: "Mobile",
		}, */
		{
			type: FieldType.CLASSIC,
			inputName: "email",
			inputType: "text",
			label: "user.email",
		},
	];

  const countryInput: DropdownInputGroup = useMemo(
		() => ({
			type: FieldType.SELECT,
			inputName: "country",
			label: isLoading ? "main.loading" : "user.user_country",
			dropdownOptions: countries ?? [],
			disabled: isLoading
		}),
    [countries, isLoading],
	);

	const emailUpdatesInput: BooleanInputGroup = {
		type: FieldType.BOOLEAN,
		inputName: "isAgreeToEmailUpdates",
		label: "user.email_updates_consent",
	};

	return (
		<section className="d-flex justify-content-center w-100 f-column gap-8">
			<h3 className="pt-2">
				<TranslatableText translationKey="user.personal_information" />
			</h3>
			{piInputs.map((input, i) => (
				<div className="pe-3" key={input.label}>
					<GenericInputGroup inputGroup={input} key={`inputs-${input.label}`} />
				</div>
			))}
			<div className="pe-3">
				<GenericInputGroup inputGroup={countryInput} />
			</div>
			<div className="pe-3">
				<GenericInputGroup inputGroup={emailUpdatesInput} />
			</div>
			<ProjectNotificationsSection />

			{/* <h3 className="pt-1">
				<TranslatableText translationKey="user.change_password" />
			</h3>
			<GenericInputGroup inputGroup={passwordInput} /> */}
		</section>
	);
};

const Footer = () => {
    const handleLogout = useHandleLogout();
    const { isValid } = useFormikContext();

    return (
        <footer className="pt-2 pe-3">
            <FormActionButtons
                isValid={isValid}
                onSubmitClick={() => { }}
                onLogoutClick={handleLogout}
                submitBorderColor="#F06320"
                submitBgColor="#F06320"
                logoutBorderColor="#999999"
            />
        </footer>
    );
};

export default UserModalForm;
